<div class="main">
  <div class="msg" appProtocolDroid="page-not-found.info">
    <h2>Cette page n'existe pas.</h2>
    <h2>Pour revenir dans le droit chemin, <a href="/">cliquez ici</a>.</h2>
  </div>
</div>
